import React from "react";

import { Toggle } from "../../../components/ui";

const STOCK_IDS = new Set(["dao", "reserved"]);
const MARKETPLACE_IDS = new Set(["ebay", "chrono", "watchfinder"]);

export function LookbookToggleList({
  daoLabel,
  inStockOn,
  onInternalProductChange,
  reserved,
  onReserveChange,
  ebay,
  onSyncEbayChange,
  chrono,
  onSyncChronoChange,
  watchFinder,
  onSyncWatchFinderChange,
  isActiveListing,
  variant = "full",
  compact = false,
}) {
  const rows = [
    {
      id: "dao",
      label: daoLabel,
      checked: inStockOn,
      onChange: onInternalProductChange,
      tone: "active",
      disabled: false,
    },
    {
      id: "reserved",
      label: "Reserved",
      checked: !!reserved,
      onChange: onReserveChange,
      tone: "reserved",
      disabled: false,
    },
    {
      id: "ebay",
      label: "eBay",
      checked: !!ebay,
      onChange: onSyncEbayChange,
      tone: "default",
      disabled: !isActiveListing,
    },
    {
      id: "chrono",
      label: "Chrono24",
      checked: !!chrono,
      onChange: onSyncChronoChange,
      tone: "default",
      disabled: !isActiveListing,
    },
    {
      id: "watchfinder",
      label: "Watchfinder",
      checked: !!watchFinder,
      onChange: onSyncWatchFinderChange,
      tone: "default",
      disabled: !isActiveListing || !watchFinder,
    },
  ];

  const visibleRows = rows.filter((row) => {
    if (variant === "stock") return STOCK_IDS.has(row.id);
    if (variant === "marketplace") return MARKETPLACE_IDS.has(row.id);
    return true;
  });

  return (
    <div
      className={`lb-toggle-list lb-toggle-list--${variant}${
        compact ? " lb-toggle-list--compact" : ""
      }`}
    >
      {visibleRows.map((row) => (
        <div key={row.id} className="lb-toggle-list__row" onClick={(e) => e.stopPropagation()}>
          <span className="lb-toggle-list__label">{row.label}</span>
          <Toggle
            bare
            size="md"
            checked={row.checked}
            onChange={row.onChange}
            disabled={row.disabled}
            tone={row.tone}
          />
        </div>
      ))}
    </div>
  );
}
